import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, AfterViewInit, EventEmitter, Output } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { PurchasingService } from '../../../services/purchasing.service';
import { VendorService } from '../../../services/vendor.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';


@Component({
	selector: 'app-vendor-lookup',
	templateUrl: './vendor-lookup.component.html',
	styleUrls: ['./vendor-lookup.component.scss']
})
export class VendorLookupComponent implements OnInit, AfterViewInit, OnDestroy {
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild('vendorsearch') customersearch: ElementRef;
	@ViewChild('resultsWrapper') resultsWrapper: ElementRef;
	@Output() vendor_selected = new EventEmitter < any > ();
	@Input() nonstock = true;
	vendorSearch= new UntypedFormControl('')
	disabled= new UntypedFormControl(false)
	filteredItems: any = [];
	allResults: any = [];
	highlightedRowIndex = -1;

	ready = false;
	vendorsearchsubscription: any = false;
	searching = false;
	sending = false;
	headercolumns: string[] = [
		'actions',
		'supplierid',
		'suppname',
		'address1',
		'telephone',
		'address4'
	];

	user:any = false;

	private destroy$ = new Subject<void>();

	constructor(private purchasingService :PurchasingService, private globalSearchService: GlobalSearchService, public vendorService : VendorService, public router: Router) { }

	ngOnInit(): void {
		this.globalSearchService.user.pipe(takeUntil(this.destroy$)).subscribe((results: any) => {
			if (results) {
				this.user = results;
			}
		});
	}

	filterVendors(): void {
		this.ready = false;
		if (this.vendorsearchsubscription) {
			this.vendorsearchsubscription.unsubscribe();
		}
		if (this.vendorSearch.value === '') {
			this.clearForm();
			return;
		}
		const searchvalue = {
			keywords: this.vendorSearch.value,
			inc_disabled: this.disabled.value
		};
		this.sending = true;
		this.searching = true;
		this.vendorsearchsubscription = this.vendorService.getVendorsPost(searchvalue).subscribe((results: any) => {
			this.sending = false;
			this.searching = false;
			this.ready = true;
			this.allResults = results || [];
			if (results?.length === 1) {
				this.selectVendor(results[0]);
			} else {
				this.filteredItems = new MatTableDataSource(this.allResults);
				this.filteredItems.sort = this.sort;
				this.filteredItems.paginator = this.paginator;
				this.highlightedRowIndex = this.allResults.length > 0 ? 0 : -1;
			}
		});
	}

	clearForm(): void {
		this.allResults = [];
		this.filteredItems = [];
		this.vendorSearch.setValue('');
		this.ready = false;
		this.searching = false;
		this.highlightedRowIndex = -1;
	}

	getCurrentPageRows(): any[] {
		if (!this.filteredItems || !(this.filteredItems instanceof MatTableDataSource)) {
			return [];
		}
		const data = this.filteredItems.filteredData || this.filteredItems.data || [];
		if (!this.paginator) {
			return data;
		}
		const start = this.paginator.pageIndex * this.paginator.pageSize;
		return data.slice(start, start + this.paginator.pageSize);
	}

	selectVendor(row: any): void {
		this.clearForm();
		this.vendor_selected.emit(row);
	}

	ngAfterViewInit(): void {
		if (this.paginator?.page) {
			this.paginator.page.pipe(takeUntil(this.destroy$)).subscribe(() => {
				this.highlightedRowIndex = 0;
			});
		}
	}

	onSearchKeydown(event: KeyboardEvent): void {
		const rows = this.getCurrentPageRows();
		if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
			if (!rows.length) {
				return;
			}
			event.preventDefault();
			if (event.key === 'ArrowDown') {
				this.highlightedRowIndex = Math.min(this.highlightedRowIndex + 1, rows.length - 1);
			} else {
				this.highlightedRowIndex = Math.max(this.highlightedRowIndex - 1, 0);
			}
			this.scrollHighlightedIntoView();
			return;
		}
		if (event.key === 'Enter') {
			event.preventDefault();
			if (rows.length && this.highlightedRowIndex >= 0 && rows[this.highlightedRowIndex]) {
				this.selectVendor(rows[this.highlightedRowIndex]);
			} else {
				this.filterVendors();
			}
		}
	}

	scrollHighlightedIntoView(): void {
		setTimeout(() => {
			const el = this.resultsWrapper?.nativeElement?.querySelectorAll?.('mat-row')?.[this.highlightedRowIndex];
			if (el) {
				el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
			}
		}, 0);
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		if (this.vendorsearchsubscription && typeof this.vendorsearchsubscription.unsubscribe === 'function') {
			this.vendorsearchsubscription.unsubscribe();
		}
	}

	announceSortChange(sortState: Sort) {
	}

}
